import { Button, Typography } from "@joonapp/web-shared"
import { toast } from "react-hot-toast"
import { useTranslation } from "react-i18next"

import { useChildPasscodeModalStore } from "./useChildPasscodeModalStore"
import { useEditPasscodeMutation } from "../../../../networking/rewards/mutations"
import useSelectedFamilyMember from "../../hooks/useSelectedFamilyMember"

const DeleteChildPasscode = () => {
  const { onClose } = useChildPasscodeModalStore()

  const { selectedProfile } = useSelectedFamilyMember()
  const { t } = useTranslation()

  const editPasscodeMutation = useEditPasscodeMutation()

  const onDelete = () => {
    if (!selectedProfile) return
    editPasscodeMutation.mutate({
      userId: selectedProfile.user.id,
      accountPasscode: null,
    })
    toast.success(t("CCP_TOAST_TURNED_OFF"))
    onClose()
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Typography variant="bodyBold">{t("CCP_DELETE_TITLE")}</Typography>
        <Typography variant="bodySmall">
          {t("CCP_DELETE_DESC", { name: selectedProfile?.user.name })}
        </Typography>
      </div>

      <div className="flex flex-row gap-4">
        <Button
          buttonType="secondary"
          text={t("QB_CANCEL")}
          onClick={onClose}
          fullWidth
        />
        <Button
          buttonType="redPrimary"
          text={t("PPC_TURN_OFF")}
          onClick={onDelete}
          fullWidth
        />
      </div>
    </div>
  )
}

export default DeleteChildPasscode
